import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Paper, Grid } from "@material-ui/core";
import styles from "./index.module.css";
import noImage from "../../../img/noImage.gif";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../../utility/utility";
import DiscountedImg from "../../../img/sale.svg";
import Review from "../../Review";
const { supportedLang } = require("../../../config");
const { forumNameConfig, firebaseBaseUrl } = require("../../../config");

const ForumList = ({ isLoading, forums }) => {
    const { t } = useTranslation();
    let langCode = useSelector((state) => state.app.lang);
    let forumCategoryId = useSelector((state) => state.app.forumCategoryId);
    const [isExpanded, setIsExpanded] = useState(false);

    // NEW: Make sure we have a fallback language from localStorage if Redux state is empty
    useEffect(() => {
        if (!langCode) {
            langCode = localStorage.getItem("selectedFlag") || "ca";
            console.log(
                `[ForumList] Using fallback language from localStorage: ${langCode}`
            );
        }
    }, [langCode]);

    const generateGridItems = (forums, langCode, condition) => {
        // NEW: Added safety check for langCode
        const safeLanguageCode =
            langCode || localStorage.getItem("selectedFlag") || "ca";
        console.log(`[ForumList] Using language: ${safeLanguageCode}`);

        return forums
            .filter((forum) => condition(forum.status))
            .map((forum) => {
                const mainImageUrl = forum.mainImageUrl
                    ? firebaseBaseUrl.replace("{0}", forum.mainImageUrl)
                    : noImage;

                const cellWidth = {
                    xs: 12,
                    sm: 6,
                    md: 3,
                };

                let priceToDisplay = forum.price;

                if (
                    forum.pricePerPerson &&
                    forum.pricePerPerson.length > 0 &&
                    forum.pricePerPerson.some((p) => p.amount > 0)
                ) {
                    const validPrices = forum.pricePerPerson
                        .filter((price) => price.amount > 0)
                        .map((price) => price.amount);

                    if (validPrices.length > 0) {
                        priceToDisplay = Math.min(...validPrices);
                    }
                }

                let priceContent = formatPrice(
                    forum.price,
                    forum.status,
                    forum.discount,
                    t("Inquire")
                );

                let engName = forum.name.find(
                    (item) => item.lang === "ca"
                )?.txt;

                let nameLink = engName
                    ? engName.replace(/[^a-zA-Z0-9]/g, "_")
                    : "";
                nameLink = nameLink + "-" + forum._id + "-" + safeLanguageCode;

                let modifiedName = forum.name.find(
                    (item) => item.lang === safeLanguageCode
                )?.txt;

                const desc = forum.description.find(
                    (item) => item.lang === safeLanguageCode
                )?.txt;

                const cellClassName =
                    forum.status === 0
                        ? `${styles.cell} ${styles.blurred}`
                        : styles.cell;

                const DISCOUNTED_PRODUCT = 3;

                return (
                    <Grid item {...cellWidth} key={forum._id}>
                        <Link
                            to={{
                                pathname: `/${forumNameConfig}/${nameLink}`,
                                search: "",
                                hash: "",
                                state: {
                                    forumId: forum._id,
                                },
                            }}
                        >
                            <Paper className={cellClassName}>
                                <div className={styles.cellContent}>
                                    <div
                                        className={`${styles.topRow} ${styles.imgDiv}`}
                                    >
                                        <img src={mainImageUrl} alt="Image" />
                                        {forum.status ===
                                            DISCOUNTED_PRODUCT && (
                                            <div
                                                className={
                                                    styles.overlappingImage
                                                }
                                            >
                                                <img
                                                    src={DiscountedImg}
                                                    alt="Overlapping Image"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className={styles.tourName}>
                                        {modifiedName}
                                    </div>
                                    <div className={styles.tourDescription}>
                                        {desc}
                                    </div>
                                    <hr />
                                    {forum.status === DISCOUNTED_PRODUCT &&
                                    forum.discount > 0 ? (
                                        <>
                                            <div className={styles.tourPrice}>
                                                {!(
                                                    forum.pricePerPerson &&
                                                    forum.pricePerPerson
                                                        .length > 0 &&
                                                    forum.pricePerPerson.some(
                                                        (p) => p.amount > 0
                                                    )
                                                ) && (
                                                    <div
                                                        className={
                                                            styles.oldPrice
                                                        }
                                                    >
                                                        {priceContent}
                                                    </div>
                                                )}
                                                <div
                                                    className={styles.newPrice}
                                                >
                                                    C${priceToDisplay}{" "}
                                                    <span
                                                        className={
                                                            styles.perPerson
                                                        }
                                                    >
                                                        /{t("PerPerson")}
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className={styles.tourPrice}>
                                            {priceContent === t("Inquire") ? (
                                                priceContent
                                            ) : (
                                                <span>
                                                    {priceContent}{" "}
                                                    <span
                                                        className={
                                                            styles.perPerson
                                                        }
                                                    >
                                                        /{t("PerPerson")}
                                                    </span>
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </Paper>
                        </Link>
                    </Grid>
                );
            });
    };

    if (isLoading === false) {
        // NEW: Added safety check for langCode using a fallback
        const safeLanguageCode =
            langCode || localStorage.getItem("selectedFlag") || "ca";

        const filteredForums =
            forumCategoryId >= 1
                ? forums.filter((forum) => forum.categoryId === forumCategoryId)
                : forums;
        if (Array.isArray(filteredForums) && filteredForums.length > 0) {
            const DISCOUNTED_ITEMS = 3;
            const gridDiscountItems = generateGridItems(
                filteredForums,
                safeLanguageCode,
                (status) => status === DISCOUNTED_ITEMS
            );
            const gridItems = generateGridItems(
                filteredForums,
                safeLanguageCode,
                (status) => status !== DISCOUNTED_ITEMS
            );

            return (
                <div className={styles.forumListContainer}>
                    <div className={styles.tourContainer}>
                        <span className={styles.leftBar}> </span>
                        <span className={styles.tourTypeTitle}>
                            {t("IntroCEO")}
                        </span>
                    </div>
                    <div className={styles.companyIntroContainer}>
                        <div
                            className={`${styles.companyDescription} ${
                                !isExpanded ? styles.collapsed : styles.expanded
                            }`}
                            dangerouslySetInnerHTML={{
                                __html:
                                    t("companyDescription") ||
                                    t("companyDescription", { lng: "ca" }),
                            }}
                        />
                        <div className={styles.companyIntroHeader}>
                            <button
                                className={styles.collapseButton}
                                onClick={() => setIsExpanded(!isExpanded)}
                            >
                                {isExpanded ? t("Collapse") : t("ReadMore")}
                            </button>
                        </div>
                    </div>
                    {gridDiscountItems.length > 0 && (
                        <div className={styles.tourContainer}>
                            <span className={styles.leftBar}> </span>
                            <span className={styles.tourTypeTitle}>
                                {t("Discounted")}
                            </span>
                        </div>
                    )}
                    <Grid container spacing={1}>
                        {gridDiscountItems}
                    </Grid>
                    {gridItems.length > 0 && (
                        <div className={styles.tourContainer}>
                            <span className={styles.leftBar}> </span>
                            <span className={styles.tourTypeTitle}>
                                {t("Recommended")}
                            </span>
                        </div>
                    )}
                    <Grid container spacing={1}>
                        {gridItems}
                    </Grid>
                    <div className={styles.tourContainer}>
                        <span className={styles.leftBar}> </span>
                        <span className={styles.tourTypeTitle}>
                            {t("TourReview")}
                        </span>
                    </div>
                    <Review />
                </div>
            );
        } else {
            return (
                <>
                    <div className={styles.workingDiv}>
                        <div className={styles.workingTxt}>
                            {t("NoTourPackage")}
                        </div>
                        <img
                            tag="Under Construction"
                            src="../bgImg/working_sm.png"
                            className={styles.responsiveImage}
                        />
                    </div>
                </>
            );
        }
    } else {
        return null;
    }
};

export default ForumList;
